<template>
  <div>
    <b-modal
      id="modal-center"
      no-close-on-backdrop
      no-close-on-esc
      size="md"
      visible
      centered
      :title="$t('sessionExpired.title')"
      :ok-title="$t('login')"
      ok-only
      @ok="gotoLogin()"
      @hide="gotoLogin()"
    >
      <p>{{this.$t('sessionExpired.text')}}</p>
    </b-modal>
  </div>
</template>

<script>
export default {
  name: 'SessionExpiredModal',

  methods: {
    gotoLogin() {
      this.$store.commit('authStore/setShowSessionExp', false);
    },
  },
};
</script>

<style>
.modal-backdrop {
  z-index: 1050;
  background-image: linear-gradient(rgba(74, 74, 74, 0.619), rgb(0, 0, 0)) !important;
  opacity: 0.7 !important;
}
</style>
